export const CircleTeaserWidgetId = 'CircleTeaserWidget';

export enum CircleTeaserWidgetAttributes {
  LINK = 'link',
  IMAGE = 'image',
  HOVER_TEXT = 'hoverText',
  ACCESSIBILITY_TEXT = 'string',
}
